import { render } from "./editModal.vue?vue&type=template&id=1f085995"
import script from "./editModal.vue?vue&type=script&lang=js"
export * from "./editModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__